// react
import { lazy } from 'react';

import CloudLayout from 'layout/CloudLayout';
import Loadable from 'components/Loadable';
import { CLOUD_BASE_PATH } from 'utils/constants';

const CloudCart = Loadable(lazy(() => import('pages/Cloud/Cart')));
const CloudTop = Loadable(lazy(() => import('pages/Cloud/Top')));
const CloudFeatures = Loadable(lazy(() => import('pages/Cloud/Features')));
const CloudPlan = Loadable(lazy(() => import('pages/Cloud/Plan')));
const CloudGlobal = Loadable(lazy(() => import('pages/Cloud/Global')));
const CartSelect = Loadable(lazy(() => import('sections/cloud/cart/Select')));
const CartForm = Loadable(lazy(() => import('sections/cloud/cart/Form')));
const CartConfirm = Loadable(lazy(() => import('sections/cloud/cart/Confirm')));
const CartComplete = Loadable(lazy(() => import('sections/cloud/cart/Complete')));
const CloudMaintenance = Loadable(lazy(() => import('pages/Cloud/Maintenance')));

// 移行分
const FaqPage = Loadable(lazy(() => import('pages/Cloud/FaqPage')));
const FlowPage = Loadable(lazy(() => import('pages/Cloud/FlowPage')));

const CloudRoutes = {
  path: CLOUD_BASE_PATH.replace(/^\//, ''),
  element: <CloudLayout />,
  children: [
    {
      path: '',
      element: <CloudTop />
    },
    {
      path: 'features',
      element: <CloudFeatures />
    },
    {
      path: 'faq',
      element: <FaqPage />
    },
    {
      path: 'flow',
      element: <FlowPage />
    },
    {
      path: 'plan',
      element: <CloudPlan />
    },
    {
      path: 'global',
      element: <CloudGlobal />
    },
    {
      path: 'maintenance',
      element: <CloudMaintenance />
    },
    {
      path: 'ec',
      element: <CloudCart />,
      children: [
        {
          path: '',
          element: <CartSelect />
        },
        {
          path: 'form',
          element: <CartForm />
        },
        {
          path: 'confirm',
          element: <CartConfirm />
        },
        {
          path: 'complete',
          element: <CartComplete />
        }
      ]
    }
  ]
};

export default CloudRoutes;
